import React from 'react';

const MarketResultB = ({ cards, winner, baseUrl }) => {
    return (
        <>
            {Object.entries(cards?.cards || {}).map(([playerKey, playerCards]) => (
                <ul key={playerKey} className="showall-card">
                    <li className="mr-2">
                        {playerKey.replace('_', ' ')} <span>-</span>
                    </li>
                    <li className="ms-1" style={{ marginLeft: 3 }}>
                        {
                            Array.isArray(playerCards)
                                ? playerCards
                                    .filter(card => typeof card === 'string' && card.trim() !== '')
                                    .map((card, idx) => (
                                        <img
                                            key={idx}
                                            className="imgClassModal"
                                            src={`${baseUrl}${card}.png`}
                                            alt={`Card ${idx}`}
                                        />
                                    ))
                                : Object.entries(playerCards || {})
                                    .filter(([_, cardValue]) => typeof cardValue === 'string' && cardValue.trim() !== '')
                                    .map(([cardKey, cardValue], idx) => (
                                        <img
                                            key={idx}
                                            className="imgClassModal"
                                            src={`${baseUrl}${cardValue}.png`}
                                            alt={`Card ${idx}`}
                                        />
                                    ))
                        }
                    </li>
                </ul>
            ))}

            {Object.entries(cards?.cardScan || {}).map(([key, cardValue]) => (
                cardValue?.trim() && (
                    <ul key={key} className="showall-card">
                        <li className="mr-2">
                            {key.replace('_', ' ')} <span>-</span>
                        </li>
                        <li className="ms-1" style={{ marginLeft: 3 }}>
                            <img
                                className="imgClassModal"
                                src={`${baseUrl}${cardValue}.png`}
                                alt={`Card ${key}`}
                            />
                        </li>
                    </ul>
                )
            ))}

            {Object.entries(cards?.cardsArr || {}).map(([key, cardArray]) => (
                <ul key={key} className="showall-card">
                    <li className="mr-2">
                        {key.replace('_', ' ')} <span>-</span>
                    </li>
                    <li className="ms-1" style={{ marginLeft: 3 }}>
                        {Array.isArray(cardArray) &&
                            cardArray
                                .filter(card => typeof card === 'string' && card.trim() !== '')
                                .map((card, idx) => (
                                    <img
                                        className="imgClassModal"
                                        key={idx}
                                        src={`${baseUrl}${card}.png`}
                                        alt={`Card ${idx}`}
                                    />
                                ))}
                    </li>
                </ul>
            ))}

        </>
    );
};



export default MarketResultB;
